module.exports = __webpack_public_path__ + "static/slide-dog-6-7d88a9b6d83f5b31acf64ba771c12cd7.png";